import { FunctionComponent, useState } from 'react';
import { Box, Button, Divider, Grid, Dialog } from '@material-ui/core';
import { TextFields, VisibilityOutlined } from '@material-ui/icons';
import { DialogueData } from 'pages/stories/interfaces/dialogueForm';
import { AssetDynamic } from 'pages/stories/interfaces/assetDynamic';
import { buildDialogueObj } from 'pages/stories/utils/dialogueObject';
import { secondsToDuration } from 'utils/time';
import { filteredDynamicAssets } from 'pages/stories/utils/asset';
import ProducerDialogue from 'pages/stories/components/Dialogue/ProducerDialogue';
import DialogueForm from 'pages/stories/components/Dialogue/Form';
import TimeLine from 'pages/stories/components/Form/TimeLine';
import EditAssetForm from 'pages/stories/components/Asset/edit';
import i18n from 'i18n';
import DialogueWrapper from 'pages/stories/components/Dialogue/Wrapper';
import { updateDialogueValues } from 'pages/stories/components/utils';
import { StoryFormData } from 'pages/stories/interface';
import ContentBoxItem from 'components/ContentBoxItem';
import ContentBox from 'components/ContentBox';

interface StoryScriptFormI {
  dynamicAssets: AssetDynamic[];
  fullScreen?: boolean;
  formData: StoryFormData;
  storyLock: boolean;
  calculatedDuration: number;
  onAddDialogueAsset: (dialogue: AssetDynamic) => void;
  onUpdateDynamicAssets: (assetsNew: AssetDynamic[]) => void;
}

const StoryScriptForm: FunctionComponent<StoryScriptFormI> = ({
  dynamicAssets,
  fullScreen,
  formData,
  storyLock,
  calculatedDuration,
  onAddDialogueAsset,
  onUpdateDynamicAssets
}: StoryScriptFormI) => {
  const [dialogueAsset, setDialogueAsset] = useState<DialogueData>();

  const [presenterdialogue, setPresenterdialogue] = useState<AssetDynamic[]>(
    []
  );

  const [editAssetMod, setEditAssetMod] = useState<AssetDynamic>();

  const onAddDialogue = () => {
    const newScriptItem = {
      presenter: '',
      camera: 1,
      dialogue: '',
      instructions: '',
      readRate: 3
    };
    setDialogueAsset(newScriptItem);
  };

  const onAddDialoguetoAsset = (key: number) => {
    const newScriptItem = {
      presenter: '',
      camera: 1,
      dialogue: '',
      instructions: '',
      readRate: 3,
      parentAsset: key
    };
    setDialogueAsset(newScriptItem);
  };

  const onShowPresenter = () => {
    setPresenterdialogue(dynamicAssets);
  };

  const onCancelPresenter = () => {
    setPresenterdialogue([]);
  };

  const onCancel = () => {
    setDialogueAsset(undefined);
  };

  const onEditAssetCancel = () => {
    setEditAssetMod(undefined);
  };

  const onEditAssetFunc = (asset: AssetDynamic, initVal: AssetDynamic) => {
    const dialogueObj = [...dynamicAssets];
    dialogueObj.forEach((pin, key) => {
      if (
        pin.assetI &&
        asset.assetI &&
        initVal.assetI &&
        initVal.assetI.positionInScript === pin.assetI.positionInScript &&
        dialogueObj[key] &&
        dialogueObj[key].assetI
      ) {
        dialogueObj[key].assetI = { ...asset.assetI };
      }
    });
    const temPAsset = [...dialogueObj];
    onUpdateDynamicAssets(temPAsset);
    setEditAssetMod(undefined);
  };

  const onSaveDialogue = (scriptObj: DialogueData, user: $Lns.User) => {
    let position = 0;

    if (dynamicAssets.length > 0) {
      dynamicAssets.forEach(item => {
        let itemPos = -1;
        if (item.assetS) itemPos = item.assetS?.positionInScript;
        else if (item.assetI) itemPos = item.assetI?.positionInScript;

        if (itemPos >= 0 && itemPos > position) {
          position = itemPos;
        }
      });
      position += 1;
    }

    const tempDialogue = buildDialogueObj(scriptObj, user, position);
    onAddDialogueAsset({ assetS: tempDialogue });
  };

  const onUpdateDialogue = (
    scriptObj: DialogueData,
    initVals: DialogueData
  ) => {
    const dialogueObjs = updateDialogueValues(
      dynamicAssets,
      scriptObj,
      initVals
    );

    const updatedAssetList = [...dialogueObjs];
    onUpdateDynamicAssets(updatedAssetList);
  };

  const onEditDialogue = (scriptObj: DialogueData) => {
    setDialogueAsset(scriptObj);
  };

  const onEditAsset = (assetI: AssetDynamic) => {
    setEditAssetMod(assetI);
  };

  const onDeleteAsset = (index: number, child?: boolean) => {
    const updatedDynamicAssets = filteredDynamicAssets(
      child,
      dynamicAssets,
      index
    );
    updatedDynamicAssets.splice(index, 1);
    onUpdateDynamicAssets([...updatedDynamicAssets]);
  };

  return (
    <Box display="flex" flexDirection="column" gridGap={16}>
      <ContentBox style={{ width: '100%' }}>
        <ContentBoxItem gridGap={16} alignItems="center !important">
          <DialogueWrapper
            title={i18n.t('pages.stories.formLabel.calculatedDuration')}
            value={secondsToDuration(calculatedDuration)}
          />
          <Box display="flex" flex={1} gridGap={8} justifyContent="flex-end">
            <Button
              disabled={storyLock}
              color="primary"
              variant="outlined"
              name="addText"
              startIcon={<TextFields />}
              onClick={onAddDialogue}
            >
              {i18n.t('pages.stories.button.addText')}
            </Button>
            <Button
              disabled={storyLock}
              color="primary"
              variant="outlined"
              startIcon={<VisibilityOutlined />}
              onClick={onShowPresenter}
            >
              {i18n.t('pages.stories.button.showProducerScript')}
            </Button>
          </Box>
        </ContentBoxItem>
      </ContentBox>
      <Divider />
      <TimeLine
        storyLock={storyLock}
        dynamicAssets={dynamicAssets}
        onEditDialog={onEditDialogue}
        onUpdateDialogue={onUpdateDialogue}
        onEditAsset={onEditAsset}
        onDeleteAsset={onDeleteAsset}
        onAddDialogue={onAddDialoguetoAsset}
      />
      {fullScreen && (
        <Grid item xs={6}>
          <ProducerDialogue initVal={dynamicAssets} formData={formData} />
        </Grid>
      )}
      {dialogueAsset && (
        <Dialog
          fullWidth
          maxWidth="sm"
          onClose={onCancel}
          aria-labelledby="simple-dialog-title"
          open
        >
          <DialogueForm
            initVal={dialogueAsset}
            onSave={onSaveDialogue}
            onEdit={onUpdateDialogue}
            onCancel={onCancel}
          />
        </Dialog>
      )}
      {presenterdialogue.length > 0 && (
        <Dialog
          fullWidth
          maxWidth="md"
          onClose={onCancelPresenter}
          aria-labelledby="simple-dialog-title"
          open
        >
          <ProducerDialogue initVal={presenterdialogue} formData={formData} />
        </Dialog>
      )}
      {editAssetMod && (
        <Dialog
          fullWidth
          maxWidth="sm"
          onClose={onEditAssetCancel}
          aria-labelledby="simple-dialog-title"
          open
        >
          <EditAssetForm
            initVal={editAssetMod}
            onEdit={onEditAssetFunc}
            onCancel={onEditAssetCancel}
          />
        </Dialog>
      )}
    </Box>
  );
};

export default StoryScriptForm;

StoryScriptForm.defaultProps = {
  fullScreen: false
};
